import React, { useEffect } from 'react';
import Carousel from 'react-material-ui-carousel'
import Image from './img/Engaging-an-AC-Compressor-Clutch.jpg'
import {makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Power from './img/electric.jpg';
import Power1 from './img/power.jpg';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import { Parallax } from "react-parallax";
import Para1 from './img/slider/outreach1.jpg';
import Para2 from './img/slide2.jpeg';
import Para3 from './img/img/loader3.jpg';
import Giver from './img/trip/give1.jpg';
import Comm from './img/slider/community.svg';
import Health from './img/slider/medical.svg';
import AOS from 'aos';
import "aos/dist/aos.css";
import { useSharedStyles, colors } from './sharedStyles';

const useStyles = makeStyles((theme) => ({
  ...useSharedStyles(),
  heroSection: {
    position: 'relative',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    overflow: 'hidden',
  },
  heroOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `rgba(44, 62, 80, 0.7)`,
    zIndex: 1,
  },
  heroContent: {
    position: 'relative',
    zIndex: 2,
    textAlign: 'center',
    color: 'white',
    maxWidth: 800,
    padding: '0 20px',
  },
  heroTitle: {
    fontSize: '3.5rem',
    fontWeight: 700,
    marginBottom: theme.spacing(2),
    textShadow: '2px 2px 4px rgba(0,0,0,0.7)',
    [theme.breakpoints.down('sm')]: {
      fontSize: '2.5rem',
    },
  },
  heroSubtitle: {
    fontSize: '1.3rem',
    marginBottom: theme.spacing(4),
    textShadow: '1px 1px 2px rgba(0,0,0,0.7)',
  },
  section: {
    padding: theme.spacing(8, 0),
  },
  lightSection: {
    background: 'linear-gradient(135deg, #F8FBFF 0%, #E8F4FD 100%)',
  },
  darkSection: {
    background: 'linear-gradient(135deg, #61DAFB 0%, #4A90E2 50%, #2C3E50 100%)',
    color: 'white',
  },
  card: {
    height: '100%',
    borderRadius: 16,
    boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-8px)',
      boxShadow: '0 16px 48px rgba(0,0,0,0.15)',
    },
  },
  cardContent: {
    padding: theme.spacing(4),
    textAlign: 'center',
  },
  cardTitle: {
    fontSize: '1.5rem',
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    color: '#2c3e50',
  },
  cardText: {
    fontSize: '1rem',
    lineHeight: 1.6,
    color: '#7f8c8d',
  },
  iconContainer: {
    width: 80,
    height: 80,
    borderRadius: '50%',
    background: 'linear-gradient(45deg, #61DAFB 30%, #FFD700 90%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 20px',
    boxShadow: '0 4px 20px rgba(97, 218, 251, 0.3)',
  },
  icon: {
    width: 40,
    height: 40,
    // filter: 'brightness(0) invert(1)',
  },
  newstartCard: {
    background: 'linear-gradient(135deg, #61DAFB 0%, #4A90E2 50%, #2C3E50 100%)',
    color: 'white',
    borderRadius: 16,
    padding: theme.spacing(4),
    marginTop: theme.spacing(4),
    boxShadow: '0 8px 32px rgba(97, 218, 251, 0.3)',
  },
  newstartTitle: {
    fontSize: '2rem',
    fontWeight: 700,
    marginBottom: theme.spacing(3),
    textAlign: 'center',
  },
  newstartItem: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: 'rgba(255,255,255,0.1)',
    borderRadius: 8,
    borderLeft: `4px solid #FFD700`,
  },
  newstartLabel: {
    fontWeight: 600,
    color: '#FFD700',
    marginBottom: theme.spacing(1),
  },
  sectionTitle: {
    fontSize: '2.5rem',
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: '3rem',
    color: '#2c3e50',
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: '-10px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '60px',
      height: 4,
      background: 'linear-gradient(45deg, #61DAFB, #FFD700)',
      borderRadius: 2,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '2rem',
    },
  },
  caro: {
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '60vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.5)',
    },
  },
  carouselContent: {
    position: 'relative',
    zIndex: 2,
    textAlign: 'center',
    color: 'white',
  },
  mapContainer: {
    height: 400,
    borderRadius: 16,
    overflow: 'hidden',
    boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
  },
}));

function Example(props) {
  const classes = useStyles();
  
  useEffect(() => {
    AOS.init({
      duration: 700
    });
  }, []);

  const items = [
    {
      name: "Outreach",
      image: Para1,
      description: "Serving communities with love and compassion"
    }
  ];

  const newstartItems = [
    {
      label: "Nutrition",
      description: "Discover why what you eat is the foundation of better health, and healthy eating can be a lot more fun than you thought."
    },
    {
      label: "Exercise",
      description: "Everyone knows they need exercise, but you won't believe how far a little exercise will go in keeping you fit."
    },
    {
      label: "Water",
      description: "Millions are chronically dehydrated, and they are aging quicker and dying younger because of it, get the facts about H2O."
    },
    {
      label: "Sunlight",
      description: "For years the sun had endured a bad reputation, but it is a key ingredient for better health."
    },
    {
      label: "Temperance",
      description: "Add years to your life by learning to use the good things moderately and avoiding the bad things entirely."
    },
    {
      label: "Air",
      description: "The air you breathe and how well you breathe it has a huge impact on how long you remain a living being."
    },
    {
      label: "Rest",
      description: "Considering that sleep is a crucial element in healing, most people are in for a disease-ridden wake up call."
    },
    {
      label: "Trust",
      description: "Nothing you've learned so far will make as much difference in your life as putting your faith in the One who made you."
    }
  ];

  return (
    <div>
      {/* Hero Section with Background Images */}
      <Carousel swipe={true} indicators={false} touch={true} animation={"slide"} interval={5000}>
        {items.map((item, i) => <Item key={i} item={item} />)}
      </Carousel>

      {/* Community Outreach Section */}
      <section className={`${classes.section} ${classes.lightSection}`}>
        <Container maxWidth="lg">
          <Typography variant="h2" className={classes.sectionTitle} data-aos="fade-up">
            Our Outreach Programs
          </Typography>
          
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <div data-aos="fade-right">
                <img 
                  src={Giver} 
                  alt="Community Outreach" 
                  style={{
                    width: '100%',
                    borderRadius: 16,
                    boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
                  }}
                />
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div data-aos="fade-left">
                <div className={classes.iconContainer}>
                  <img src={Comm} alt="Community" className={classes.icon} />
                </div>
                <Typography variant="h3" className={classes.cardTitle} style={{textAlign: 'center', marginBottom: '1.5rem'}}>
                  Community Outreach
                </Typography>
                <Typography variant="body1" className={classes.cardText} style={{fontSize: '1.1rem', lineHeight: 1.8}}>
                  We base our Community Outreach program on the Gospel of Jesus, Matthew 25: 42, 43 & 45. 
                  "For I was hungry and you gave me no food, I was thirsty and you gave me no drink. 
                  I was a stranger and you did not take me in, naked and you did not clothe me, 
                  sick and in prison and you did not visit me." Then he will answer them, saying, 
                  "Assuredly, I say to you, inasmuch as you did not do it to one of the least of these, 
                  you did not do it to me."
                </Typography>
              </div>
            </Grid>
          </Grid>
        </Container>
      </section>

      {/* Health and Medical Outreach Section */}
      <section className={classes.section}>
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <div data-aos="fade-right">
                <div className={classes.iconContainer}>
                  <img src={Health} alt="Health" className={classes.icon} />
                </div>
                <Typography variant="h3" className={classes.cardTitle} style={{textAlign: 'center', marginBottom: '1.5rem'}}>
                  Health and Medical Outreach
                </Typography>
                <Typography variant="body1" className={classes.cardText} style={{fontSize: '1.1rem', lineHeight: 1.8}}>
                  For Health and Medical Outreach, we promote the 8 Bible Secrets for a longer and stronger life. 
                  The Amazing Health Benefits when we use The Newstart Lifestyle.
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div data-aos="fade-left">
                <Card className={classes.newstartCard}>
                  <Typography variant="h4" className={classes.newstartTitle}>
                    NEWSTART Lifestyle
                  </Typography>
                  <Grid container spacing={2}>
                    {newstartItems.map((item, index) => (
                      <Grid item xs={12} sm={6} key={index}>
                        <div className={classes.newstartItem}>
                          <Typography variant="h6" className={classes.newstartLabel}>
                            {item.label}
                          </Typography>
                          <Typography variant="body2" style={{fontSize: '0.9rem'}}>
                            {item.description}
                          </Typography>
                        </div>
                      </Grid>
                    ))}
                  </Grid>
                </Card>
              </div>
            </Grid>
          </Grid>
        </Container>
      </section>

      {/* Map Section */}
      <section className={`${classes.section} ${classes.lightSection}`}>
        <Container maxWidth="lg">
          <Typography variant="h2" className={classes.sectionTitle} data-aos="fade-up">
            Find Us
          </Typography>
          <div className={classes.mapContainer} data-aos="fade-up">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3104.8484336332685!2d-76.81632558464938!3d38.90458117956952!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7eab2795cc2e9%3A0x3b7e3088d8779114!2s1011%20Winged%20Foot%20Dr%2C%20Bowie%2C%20MD%2020721%2C%20USA!5e0!3m2!1sen!2sgh!4v1606680803222!5m2!1sen!2sgh" 
              width="100%" 
              height="400" 
              style={{border: 0}} 
              title="location" 
              loading="lazy"
            />
          </div>
        </Container>
      </section>
    </div>
  );
}

function Item(props) {
  const classes = useStyles();
  
  return (
    <div 
      className={classes.heroSection} 
      style={{
        backgroundImage: `linear-gradient(rgba(44, 62, 80, 0.7), rgba(44, 62, 80, 0.7)), url(${props.item.image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className={classes.heroOverlay}></div>
      <div className={classes.heroContent}>
        <Typography variant="h1" style={{fontSize: '3.5rem', fontWeight: 700, marginBottom: '1rem'}} data-aos="flip-right">
          {props.item.name}
        </Typography>
        <Typography variant="h5" style={{fontSize: '1.3rem'}} data-aos="zoom-in">
          {props.item.description}
        </Typography>
      </div>
    </div>
  );
}

export default Example;


